import { Checkbox, Divider, Row, RowSize, WarningPanel } from "@/components";
import { useSort } from "@/pages/requests/components/users/hooks/use-sort";
import { UsersField } from "@/pages/requests/components/users/types";
import { Person, selectRequestFormStore, useBoundStore } from "@/services";
import clsx from "clsx";
import { map } from "lodash";
import { useEffect, useState, ChangeEvent } from "react";
import { useFormContext } from "react-hook-form";
import styles from "../../styles.scss";
import { TableHeader } from "./table-header";
import { TableRow } from "./table-row";

export const UsersB = ({
  className,
  withoutNotices,
  onSetAccurancy,
}: {
  className?: string;
  withoutNotices?: boolean;
  onSetAccurancy?: (value: boolean) => void;
}) => {
  const { requestFormData } = useBoundStore(selectRequestFormStore);

  const [data, updateData] = useState<Person[]>(
    requestFormData?.Personnels || [],
  );

  const {
    trigger,
    getValues,
    formState: { errors },
  } = useFormContext();

  const isCheckedUsersAccurancy = Boolean(getValues(UsersField.UsersAccurancy));

  useEffect(() => {
    trigger(UsersField.Users);
    trigger(UsersField.UsersAccurancy);
  }, [trigger, getValues]);

  const { sortDirections, handleSort } = useSort(data, updateData);

  const handleSetIsChecked = async (e: ChangeEvent<HTMLInputElement>) => {
    const _isChecked = e.target.checked;

    onSetAccurancy?.(_isChecked);

    await trigger(UsersField.UsersAccurancy);
  };

  return (
    <>
      {!withoutNotices && (
        <>
          <Row className={styles.notice}>
            All personnel information and details should be classified in
            Arabic. All visas/residency must be issued from emirate of Abu
            Dhabi.
          </Row>

          {errors[UsersField.Users] && (
            <WarningPanel
              title="Error Encountered"
              text="Please return to previous step to resolve it."
            />
          )}
        </>
      )}

      <div className={clsx(styles.tableWrap, className)}>
        <div className={styles.table}>
          <TableHeader onSortBy={handleSort} sortDirections={sortDirections} />

          {data.length ? (
            map(data, item => (
              <TableRow key={item.WorkerEidUnifiedNumber} item={item} />
            ))
          ) : (
            <Row className={styles.emptyRow}>No data available</Row>
          )}
        </div>
      </div>

      {!withoutNotices && (
        <>
          <Row size={RowSize.ExtraLarge}>
            <Divider />
          </Row>

          <Row className={clsx(styles.notice, styles.noticeWithCheckbox)}>
            <Checkbox
              name="accuracy"
              checked={isCheckedUsersAccurancy}
              className={styles.checkbox}
              onChange={handleSetIsChecked}
            />
            <span
              style={{ cursor: "pointer" }}
              onClick={() =>
                handleSetIsChecked({
                  target: { checked: !isCheckedUsersAccurancy },
                } as ChangeEvent<HTMLInputElement>)
              }
            >
              The company undertakes of accuracy of the information of the
              provided personnel&apos;s
            </span>
          </Row>
        </>
      )}
    </>
  );
};
